import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../../Constants';

function checkoutPreview(
  token,
  basketUrl,
  guestEmail,
  shippingMethodCode,
  country,
  firstName,
  lastName,
  addressLine1,
  addressLine2,
  addressCity,
  addressState,
  addressZip,
) {
  const url = 'api/checkout/preview/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      basket: basketUrl,
      guest_email: guestEmail,
      // total: total,
      shipping_method_code: shippingMethodCode,
      // shipping_charge: shippingCharge,
      shipping_address: {
        country,
        first_name: firstName,
        last_name: lastName,
        line1: addressLine1,
        line2: addressLine2,
        line3: '',
        line4: addressCity,
        notes: '',
        phone_number: '',
        postcode: addressZip,
        state: addressState,
        title: '',
      },
    },
  });
}

function getShippingMethods(
  token,
  basketUrl,
  country,
  firstName,
  lastName,
  addressLine1,
  addressLine2,
  addressCity,
  addressState,
  addressZip,
) {
  const url = 'api/basket/shipping-methods/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      // basket: basketUrl,
      country,
      first_name: firstName,
      last_name: lastName,
      line1: addressLine1,
      line2: addressLine2,
      line3: '',
      line4: addressCity,
      notes: '',
      phone_number: '',
      postcode: addressZip,
      state: addressState,
      title: '',
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getCountries(token) {
  const url = 'api/countries/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function placeOrder(
  token,
  basketUrl,
  guestEmail,
  total,
  shippingMethodCode,
  shippingCharge,
  country,
  firstName,
  lastName,
  addressLine1,
  addressLine2,
  addressCity,
  addressState,
  addressZip,
  sources,
) {
  const url = 'api/checkout/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      basket: basketUrl,
      guest_email: guestEmail,
      total,
      shipping_method_code: shippingMethodCode,
      shipping_charge: shippingCharge,
      shipping_address: {
        country,
        first_name: firstName,
        last_name: lastName,
        line1: addressLine1,
        line2: addressLine2,
        line3: '',
        line4: addressCity,
        notes: '',
        phone_number: '',
        postcode: addressZip,
        state: addressState,
        title: '',
      },
      sources,
    },
  });
}

function submitPayment(
  token,
  total,
  customerId,
  paymentMethod,
  type,
  useStoreCredit,
) {
  const url = 'api/payment/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      total,
      customer_id: customerId,
      payment_method: paymentMethod,
      payment_type: type,
      use_store_credit: useStoreCredit,
    },
  });
}


export {
  checkoutPreview,
  getShippingMethods,
  getCountries,
  placeOrder,
  submitPayment,
};
